import {
  GetLessonById_getLessonById,
  GetLessonById_getLessonById_unit,
  GetLessonById_getLessonById_integratedUnit,
} from 'approot/lesson/__generated__/GetLessonById';
import {
  GetAssessmentById_getAssessmentById,
  GetAssessmentById_getAssessmentById_unit,
  GetAssessmentById_getAssessmentById_integratedUnit,
} from 'approot/assessment/__generated__/GetAssessmentById';
import { GetGuestLessonById_getLessonById } from 'approot/lesson/__generated__/GetGuestLessonById';

type ContentItem =
  | GetLessonById_getLessonById
  | GetGuestLessonById_getLessonById
  | GetAssessmentById_getAssessmentById
  | null
  | undefined;

export function getContentUnit(
  contentItem: ContentItem,
  params: { parentId: string } | undefined
): [
  (
    | GetLessonById_getLessonById_unit
    | GetAssessmentById_getAssessmentById_unit
    | GetLessonById_getLessonById_integratedUnit
    | GetAssessmentById_getAssessmentById_integratedUnit
    | undefined
    | null
  ),
  boolean
] {
  const unitId: number | undefined = params?.parentId
    ? parseInt(params.parentId)
    : contentItem?.unit.id;

  if (!contentItem) {
    return [undefined, false];
  }

  return contentItem.unit.id === unitId
    ? [contentItem.unit, false]
    : [contentItem.integratedUnit, true];
}
